import { createResourceStore } from './createResourceStore';
import { enrichWithDeviceInfo } from '../shared/lib/deviceInfo';
import { FILTER_CACHE_TTL, SEARCH_OPTIONS_LIMIT } from '../shared/config/constants';

const useOrganisationStore = createResourceStore({
  endpoint: '/admin/organisations',
  collectionKey: 'organisations',
  itemKey: 'organisation',
  paginated: true,
  totalKey: 'totalOrganisations',
  hasFetchById: true,
  enrichUpdate: enrichWithDeviceInfo,
  extraState: { organisation: null },
  cache: { ttl: FILTER_CACHE_TTL.organisations },
  mapListParams: (page, search = '', tokensSort = '', trialEndSort = '') => ({
    ...(page != null && page !== '' ? { page } : {}),
    search,
    tokensSort,
    trialEndSort,
  }),
  methods: {
    fetch: 'fetchOrganisations',
    create: 'createOrganisation',
    update: 'updateOrganisation',
    delete: 'deleteOrganisation',
    fetchById: 'fetchOrganisationById',
  },
  extend: (_set, _get, { apiClient }) => ({
    searchOrganisations: async ({ search = '', limit = SEARCH_OPTIONS_LIMIT } = {}) => {
      try {
        const data = await apiClient.get('/admin/organisations', { search, limit });
        return data.organisations || [];
      } catch (error) {
        console.error('Failed to search organisations:', error);
        return [];
      }
    },
  }),
});

export default useOrganisationStore;
